import React from 'react';

const Contact = () => (
  <h1>Contact us!</h1>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/container/Contact.js